module.exports = __webpack_public_path__ + "assets/img/1261587028481_.pic_hd.819602ba.jpg";